export const prescriptionColors = {
    prescriptionGeneral: { main: "#ccc" },
    prescriptionMissed: { main: "#dd7e92" },
    prescriptionNow: { main: "#e00814" },
};
